import { Fragment, useEffect, useState } from 'react';

function TripAdvisorReviews(props) {
	const [initialized, setInitialized] = useState(false);

	useEffect(() => {
		const scriptId = 'ta-widget-script';
		
		const initWidget = () => {
			if (window.taValidate) {
				window.taValidate();
				setInitialized(true);
			}
		};
		
		if (!document.getElementById(scriptId)) {
			const script = document.createElement('script');
			script.id = scriptId;
			script.async = true;
			script.src = "https://www.jscache.com/wejs?wtype=selfserveprop&uniq=839&locationId=32710848&lang=en_US&rating=true&nreviews=2&writereviewlink=true&popIdx=true&iswide=true&border=false&display_version=2";
			
			script.onload = initWidget;
			document.body.appendChild(script);
			
			setTimeout(() => {
				initWidget();
			}, 800);
		}
		else {
			initWidget();
		}
	}, []);

	return <div id="TA_selfserveprop839" className={'tripadvisor-widget TA_selfserveprop flex justify-center transition-all '+props.className+(initialized ? ' opacity-100' : ' opacity-0')}>
		<ul id="UOWkyFCZpSV" className="TA_links x65o4w49C">
			<li id="Yak4qqt" className="S55NH9A">
				<a target="_blank" href="//www.tripadvisor.com/Attraction_Review-g189970-d32710848-Reviews-World_In_Words_Manuscript_Exhibition-Reykjavik_Capital_Region.html">
					<img src="//www.tripadvisor.com/img/cdsi/img2/branding/v2/Tripadvisor_lockup_horizontal_secondary_registered-11900-2.svg" alt="TripAdvisor"/>
				</a>
			</li>
		</ul>
	</div>
}

export default TripAdvisorReviews;